import { css } from '@emotion/core';
import styled from '@emotion/styled';

import { compose, layout, space } from 'styled-system';
import { TabList } from 'react-tabs';

const ProfileTabList = styled(TabList)(
  ({ theme }) => css`
    margin-bottom: -1px;
    font-size: ${theme.fontSizes.sm};
    line-height: ${theme.lineHeights.text};
    padding: 0;
    list-style: none;
    display: flex;

    > * + * {
      margin-left: ${theme.space.xs};
    }
  `,
  compose(layout, space)
);

export default ProfileTabList;
// This is to let the Tabs component know this is a custom TabList

ProfileTabList.tabsRole = 'TabList';
